import React from 'react';
import Tab from '@material-ui/core/Tab';

export function PasslyTab(props: any) {
    return <Tab {...props} disableRipple={true} />;
}

